import React, { useState, useEffect } from "react";
import { Trans } from "react-i18next";
import TemplatePicker from "./TemplatePicker";
import ContentCreation from "./ContentCreation";
import ContentSetup from "./ContentSetup";
import DonePage from "./ContentDone";
import { Card, Stepper, Step, StepLabel, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { contentClient } from "../../AxiosClient";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import axios from "../../AxiosClient";
import {
  setCustomFields,
  whatsUsingThem,
} from "../../redux/actions/customFieldsActions";
import { connect } from "react-redux";
import { containsScriptOrSVG, containsBadCharacter } from "../../utils/ContentChecker";
import {
  setGlobalAlert
} from "../../redux/actions/universalActions";
const useStyles = makeStyles((theme) => ({
  stepper: {
    marginBottom: 10,
    marginTop: 10,
  },
}));

function CreateContentFlow(props) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [content, setContent] = useState({
    meta: [],
    revalidationBehaviour: "NOT_SET",
  });
  const [template, setTemplate] = useState({});
  const [sections, setSections] = useState([]);
  const [updatedSectionFromTemplate, setUpdatedSectionFromTemplate] = useState(
    false
  );
  const [fileUpload, setFileUpload] = useState(false);
  const [saving, setSaving] = useState(false);
  const currentCustomFields = useSelector(
    (state) => state.customFields.currentCustomFields
  );
  const { enqueueSnackbar } = useSnackbar();

  useEffect(
    () => {
      if (activeStep < 1) {
        props.setCustomFields([]);
        props.whatsUsingThem("");
      }
    },
    [activeStep]
  );

  useEffect(
    () => {
      if (props.createRevision) {
        let newSection = [...sections];
        newSection.map((section) => {
          const result = template.templateSections.filter((tempSection) => {
            if (tempSection.id === section.sectionID) {
              section.name = tempSection.name;
              section.sortOrder = tempSection.sortOrder;
              section.sectionColumn = tempSection.sectionColumn;
              section.classification = tempSection.classification;
              section.sectionColumn = tempSection.sectionColumn;
            }
          });
        });
        setSections(newSection);
        setUpdatedSectionFromTemplate(true);
      }
    },
    [template]
  );

  useEffect(
    () => {
      if (props.edit) {
        setActiveStep(1);
        if (props.content.file) {
          setFileUpload(true);
          setContent({
            ...props.content,
            meta: JSON.parse(props.content.meta),
          });
        } else {
          if (props.content.fileId) {
            setFileUpload(true);
            axios
              .get(`/document/file/${props.content.fileId}/meta`)
              .then((res) => {
                setContent({
                  ...props.content,
                  file: {
                    ...res.data,
                  },
                  meta: JSON.parse(props.content.meta),
                });
              });
          } else {
            setContent({
              ...props.content,
              meta: props.content.meta ? JSON.parse(props.content.meta) : [],
            });
          }
        }
        let templateId = props.content.layout
          ? props.content.layout
          : props.content.template && props.content.template.id
        if (templateId != null) {
          getTemplate(templateId);
        }
      }
      return function cleanup() {
        props.setCustomFields([]);
        props.whatsUsingThem("");
      };
    },
    [props.content]
  );
  const getTemplate = (id) => {
    contentClient.get(`/template/${id}`).then((res) => {
      setTemplate(res.data);
    });
  };

  useEffect(
    () => {
      setSections(props.sections);
    },
    [props.sections]
  );

  const nextFileUpload = () => {
    setActiveStep(activeStep + 1);
    setFileUpload(true);
  };

  const next = () => {
    if (activeStep === 2) {
      saveContent();
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const back = () => {
    if (props.edit && activeStep === 1) {
      props.onClose();
    } else {
      if (activeStep === 1) {
        setFileUpload(false);
        //note title not retained
        setContent({ meta: [], revalidationBehaviour: "NOT_SET" });
      } else if (activeStep === 2) {
        //we are going back to an edited piece of content so retain the title
        setContent({ title: content.title, meta: [], revalidationBehaviour: "NOT_SET" });
      }
      setActiveStep(activeStep - 1);
    }
  };

  const saveContent = () => {
    if (sections) {
      if (containsScriptOrSVG(sections.map(section=> section.defaultText))) {
        props.setGlobalAlert({type:"error", message:"harmful_content", open:true})
        return;
      } else if (containsBadCharacter(sections.map(section=> section.defaultText))) {
        props.setGlobalAlert({type:"error", message:"unusable_character", open:true})
        return;
      }
    }
    setSaving(true);
    let patchRevision =
      (props.revisionEdit && !props.createRevision) ||
      (content.draft && content.revisionId);
    let contentPayload = !template
      ? content
      : {
          ...content,
          template,
        };
    if (contentPayload.author) {
      if (patchRevision) {
        contentPayload.author = null;
      } else {
        contentPayload.author = contentPayload.author;
      }
    }
    if (patchRevision) {
      contentPayload.sectionsDTOs = sections;
      contentPayload.knowledgeItemId = contentPayload.itemID
        ? contentPayload.itemID
        : contentPayload.itemId;
      contentPayload.approved = contentPayload.approved ? 1 : 0;
    } else {
      contentPayload.sections = sections;
    }
    contentPayload.meta = JSON.stringify(contentPayload.meta);
    let customFields = [];
    for (let i = 0; i < currentCustomFields.length; i++) {
      customFields.push(currentCustomFields[i]);
    }
    contentPayload.customFieldsRVOs = customFields;
    let url;
    let itemId = content.knowledgeItemId
      ? content.knowledgeItemId
      : content.itemID
        ? content.itemID
        : content.itemId;
    if (props.createRevision && !patchRevision) {
      url = `/knowledgeitem/${itemId}/revision/`;
    } else if (patchRevision) {
      url = `/knowledgeitem/${itemId}/revision/${content.revisionId}`;
    } else if (props.edit) {
      content.itemID
        ? (url = `/knowledgeitem/${content.itemID}/revision`)
        : (url = `/knowledgeitem/${content.itemId}/revision`);
    } else {
      url = "/knowledgeitem/";
    }
    
    if(contentPayload.revalidationDate) contentPayload.revalidationDate = Date.parse(contentPayload.revalidationDate);
    if(contentPayload.visibleDate)contentPayload.visibleDate =  Date.parse(contentPayload.visibleDate);
    if(contentPayload.expiryDate) contentPayload.expiryDate = Date.parse(contentPayload.expiryDate);

    contentPayload.resolvingReworks = props.resolvingReworks;
    contentClient({
      method: patchRevision ? "patch" : "post",
      url: url,
      data: { ...contentPayload },
    })
      .then((res) => {
        setSaving(false);
        if (props.createRevision) {
          enqueueSnackbar(
            <Trans i18nKey="revision_created_successfully">
              revision_created_successfully
            </Trans>,
            { variant: "success" }
          );
          props.onRevisionAdded(res.data);
        } else if (patchRevision) {
          enqueueSnackbar(
            <Trans i18nKey="revision_edited_successfully">
              revision_edited_successfully
            </Trans>,
            { variant: "success" }
          );
          props.onRevisionEdit && props.onRevisionEdit(res.data);
          props.onSubmit && props.onSubmit(res.data);
        } else if (props.edit) {
          enqueueSnackbar(
            <Trans i18nKey="revision_created_successfully">
              revision_created_successfully
            </Trans>,
            { variant: "success" }
          );
          props.onSubmit(res.data);
        } else {
          setActiveStep(activeStep + 1);
        }
      })
      .catch((err) => {
        setSaving(false);
        enqueueSnackbar(
          <Trans
            i18nKey="create_content_error_snackbar"
            values={{ error: err.response ? err.response.data.message : "" }}
          >
            create_content_error_snackbar
          </Trans>,
          { variant: "error" }
        );
      });
  };

  const updateSection = (section) => {
    let newSections = [...sections];
    for (let i = 0; i < newSections.length; i++) {
      if ((newSections[i].id && newSections[i].id === section.id) || (newSections[i].reusableSectionId && newSections[i].reusableSectionId === section.reusableSectionId)) {
        newSections[i] = section;
      }
    }
    setSections(newSections);
  };

  const restartFlow = () => {
    setActiveStep(0);
    setContent({ meta: [] });
    setTemplate({});
    setSections([]);
    setFileUpload(false);
  };

  return (
    <div
      style={
        !props.noBackground
          ? {
              overflow: "auto",
              padding: "0 10px 0 10px",
              height: "100%",
              flex: 1,
              backgroundColor: props.noElevation ? "" : "#eae0d7",
              backgroundImage: props.noElevation
                ? ""
                : "url('../../images/background.svg')",
            }
          : { overflow: "auto" }
      }
    >
      <Card
        className={!props.noBackground && classes.stepper}
        elevation={props.noElevation ? 0 : 1}
      >
        {props.close && props.close}
        {props.edit ? (
          <Stepper activeStep={activeStep - 1}>
            <Step completed={activeStep > 1}>
              <StepLabel>
                <Trans i18nKey="edit_content_step" />
              </StepLabel>
            </Step>
            <Step completed={activeStep > 2}>
              <StepLabel>
                <Trans i18nKey="edit_content_setup_step" />
              </StepLabel>
            </Step>
          </Stepper>
        ) : (
          <Stepper activeStep={activeStep}>
            <Step completed={activeStep > 0}>
              <StepLabel>
                <Trans i18nKey="create_content_layout_template_selection" />
              </StepLabel>
            </Step>
            <Step completed={activeStep > 1}>
              <StepLabel>
                <Trans i18nKey="create_content_layout_create_content" />
              </StepLabel>
            </Step>
            <Step completed={activeStep > 2}>
              <StepLabel>
                <Trans i18nKey="create_content_layout_final_content_setup" />
              </StepLabel>
            </Step>
          </Stepper>
        )}
      </Card>
      <>
        {activeStep === 0 && (
          <TemplatePicker
            noFromFile={props.noFromFile}
            noElevation={props.noElevation}
            isStart
            show={activeStep === 0}
            style={{ display: activeStep === 0 ? "block" : "none" }}
            onTemplateSelected={(template) => {
              setTemplate(template);
              setSections(template.templateSections);
            }}
            nextFileUpload={nextFileUpload}
            nextText={
              <Trans i18nKey="create_content_use_template_button">
                create_content_use_template_button
              </Trans>
            }
            next={next}
          />
        )}
        {(activeStep === 2 || activeStep === 1) && (
          <ContentCreation
            id="content-creation"
            noElevation={props.noElevation}
            fileUpload={fileUpload}
            file={content.file}
            backText={props.edit ? <Trans i18nKey="global_cancel" /> : null}
            show={activeStep === 1}
            next={next}
            activeStep={activeStep}
            style={{ display: activeStep === 1 ? "block" : "none" }}
            back={back}
            content={content}
            template={template}
            sections={
              !props.createRevision
                ? sections
                : updatedSectionFromTemplate
                  ? sections
                  : undefined
            }
            setSections={setSections}
            updateContent={(content) => setContent(content)}
            updateSection={updateSection}
            edit={props.edit}
            noBackground={props.noBackground}
            revisions={props.revisions}
          />
        )}
        {activeStep === 2 && (
          <ContentSetup
            noElevation={props.noElevation}
            createRevision={props.createRevision}
            show={activeStep === 2}
            next={next}
            back={back}
            edit={props.edit}
            loading={saving}
            nextText={
              props.edit ? (
                <Trans i18nKey="edit_content_save_button">
                  edit_content_save_button
                </Trans>
              ) : (
                <Trans i18nKey="create_content_create_button">
                  create_content_create_button
                </Trans>
              )
            }
            style={{ display: activeStep === 2 ? "block" : "none" }}
            content={content}
            template={template}
            revisionEdit={props.revisionEdit}
            updateContent={(content) => setContent(content)}
            noBackground={props.noBackground}
          />
        )}
        {activeStep === 3 &&
          !props.edit && (
            <DonePage
              noElevation={props.noElevation}
              show={activeStep === 3}
              style={{ display: activeStep === 3 ? "block" : "none" }}
              isEnd
              title={content.title}
              restart={restartFlow}
            />
          )}
      </>
    </div>
  );
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  setCustomFields,
  whatsUsingThem,
  setGlobalAlert,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateContentFlow);
